import type { ArchiveLinkResponseAction } from './archiveAdLink.action';
import type { GetAdLinksResponseAction } from './getAdLinks.action';
import type { UpdateAdLinksAction } from './updateAdLinks.action';

export * from './getAdLinks.action';
export * from './updateAdLinks.action';
export * from './archiveAdLink.action';

export type AdLinkAction = GetAdLinksResponseAction | UpdateAdLinksAction | ArchiveLinkResponseAction;
